function formatNumber(value: number) {
    return new Intl.NumberFormat('en', {
        maximumFractionDigits: 2,
        notation: 'compact',
        compactDisplay: 'short'
    }).format(value);
}

export default formatNumber;
